import { Component } from '@angular/core';

@Component({
  selector: 'app-visit-detail',
  templateUrl: './visit-detail.component.html',
  styleUrl: './visit-detail.component.css'
})
export class VisitDetailComponent {

}
